/**
 * Parses a purityStandard string into a numeric factor (0–1).
 * Used to adjust metal rate before sending to backend.
 */
export function parsePurityFactor(purityStandard) {
  if (!purityStandard) return 1;
  const s = purityStandard.trim().toLowerCase();

  // Fineness patterns: "925 silver", "999 fine silver", "950 platinum", or plain "925"
  const finenessMatch = s.match(/\b(999|958|950|925|916|900|850|835|800|\d{3})\b/);
  if (finenessMatch) return Number(finenessMatch[1]) / 1000;

  // Percentage patterns: "85% silver", "80% silver"
  const pctMatch = s.match(/^(\d+)%/);
  if (pctMatch) return Number(pctMatch[1]) / 100;

  // Gold karat patterns
  const karatMap = { "24k": 0.999, "22k": 0.916, "18k": 0.750, "14k": 0.585 };
  for (const [k, v] of Object.entries(karatMap)) {
    if (s.startsWith(k)) return v;
  }

  return 1; // "Other" or unrecognised — no adjustment
}

